


























import { computed, defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import ProductVariants from '@shared/components/ProductVariants/ProductVariants.vue';
import useCartCookie from '@shared/composables/useCartCookie';
import { DiscountProgress } from '@shared/composables/useShopifyDiscounts';
import { ISelectedOption } from '@shared/types/IBundledProduct';
import { UCIcon } from '@shared/ui';
import { productGetters } from '@unified-commerce/gpc-vue-storefront-shopify';

import FancyButton from './FancyButton.vue';

export default defineComponent({
  name: 'CartFreeGift',
  components: { FancyButton, ProductVariants, UCIcon },
  props: {
    discountProgress: {
      type: Object as PropType<DiscountProgress>,
      default: null,
    },
  },
  setup({ discountProgress: { discount, numberGiftsEligibleFor } }) {
    const { addItem, loading } = useCartCookie();
    const selectedVariantId = ref<string | null>(null);

    const hasOptions = computed(() => discount.options?.some(({ values }) => values.length > 1));
    const disabled = computed(
      () => loading.value || (hasOptions.value && !selectedVariantId.value),
    );
    const image = computed(() =>
      discount.images[0]
        ? {
            src: productGetters.getCoverImage(discount, 'small'),
            alt: discount.images[0].altText,
          }
        : null,
    );

    const discountVariantSelected = (selectedOptions: ISelectedOption[]) => {
      const variant = discount.variants?.find((variant) =>
        variant.selectedOptions.every(
          ({ name, value }) => selectedOptions.find((s) => s.name === name)?.value === value,
        ),
      );
      if (!variant) return;
      selectedVariantId.value = variant.id;
    };

    const addFreeGift = () => {
      const variantId = hasOptions.value ? selectedVariantId.value : discount.variants?.[0].id;
      addItem({
        product: { variantId: variantId || '' },
        quantity: hasOptions.value ? 1 : numberGiftsEligibleFor,
      });
    };

    return {
      hasOptions,
      image,
      discountVariantSelected,
      addFreeGift,
      disabled,
      loading,
    };
  },
});
